import { useEffect, useRef, useState } from 'react'
import Section from '@/components/Section'
import { useSeo } from '@/components/usePageTitle'

/**
 * Interactive API reference: Swagger UI rendering /api/openapi.json. The UI
 * bundle is large, so it loads only on this page, from our own origin (no
 * third-party scripts).
 */
export default function ApiDocs() {
  useSeo({
    title: 'API',
    description: 'The ColorMark API: search the registry, look colors up, get swatch images, and register a color. OpenAPI 3.1 with an interactive reference.',
  })
  const host = useRef<HTMLDivElement>(null)
  const [state, setState] = useState<'loading' | 'ready' | 'failed'>('loading')

  useEffect(() => {
    let alive = true
    Promise.all([import('swagger-ui-dist/swagger-ui-bundle.js'), import('swagger-ui-dist/swagger-ui.css')])
      .then(([{ default: SwaggerUIBundle }]) => {
        if (!alive || !host.current) return
        SwaggerUIBundle({
          url: '/api/openapi.json',
          domNode: host.current,
          deepLinking: true,
          docExpansion: 'list',
          defaultModelsExpandDepth: 0,
          tryItOutEnabled: true,
          displayRequestDuration: true,
        })
        setState('ready')
      })
      .catch(() => {
        if (alive) setState('failed')
      })
    return () => {
      alive = false
    }
  }, [])

  return (
    <Section className="pt-40 md:pt-52">
      <div className="mx-auto max-w-[1800px]">
        <h1>ColorMark API.</h1>
        <p className="mt-8 max-w-3xl">
          Search the registry, look colors up, fetch a swatch image, or register a color from your own code. Read
          endpoints are open JSON. The specification is at{' '}
          <a href="/api/openapi.json">/api/openapi.json</a> (OpenAPI 3.1), and the base URL is{' '}
          <code className="font-body text-[0.95em]">https://colormark.org/api</code>.
        </p>
        <div className="mt-6 text-sm text-neutral-500" aria-live="polite">
          {state === 'loading' && 'Loading the interactive reference…'}
          {state === 'failed' && 'The interactive reference could not load; the specification link above still works.'}
        </div>
        <div ref={host} className="swagger-host mt-6 font-body" />
      </div>
    </Section>
  )
}
